import * as React from 'react';
import * as styles from './ChangedPhoneMessageDescription.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChangedPhoneMessageDescription = function ChangedPhoneMessageDescription() {
  return /*#__PURE__*/_jsxs("ul", {
    className: styles['description'],
    children: [/*#__PURE__*/_jsx("li", {
      children: "\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u043A\u043E\u043F\u0438\u0438 \u0447\u0435\u043A\u043E\u0432 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0441\u0447\u0451\u0442\u0430"
    }), /*#__PURE__*/_jsx("li", {
      children: "\u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0441\u0443\u043C\u043C\u0443 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u0430"
    }), /*#__PURE__*/_jsx("li", {
      children: "\u0440\u0430\u0441\u0441\u043A\u0430\u0436\u0438\u0442\u0435 \u043E \u0432\u0430\u0448\u0438\u0445 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0445"
    })]
  });
};